<!--
  this script is used to create the cookies admin HTML snippet
  @since PM (19.08.2020)
-->
<section *ngIf="visible" class="alert alert-dark {{slug}}">
  <row-paragraph [paragraph]="paragraph" [margin]="false"></row-paragraph>
  <hr>
  <button type="button" class="btn btn-dark" [innerText]="theo('accept')" (click)="visible = !visible"></button>
</section>
